import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';
import { environment } from 'environments/environment';
@Component({
  selector: 'app-adquirentes',
  templateUrl: './adquirentes.component.html',
  styleUrls: ['./adquirentes.component.scss']
})
export class AdquirentesComponent {
  Label_Proveedor=environment.LABEL_PROVEEDOR;
  Label_Proveedores=environment.LABEL_PROVEEDORES;
  Label_Adquirente=environment.LABEL_ADQUIRENTE;
  Label_Adquirentes=environment.LABEL_ADQUIRENTES;
  user:any;
  flag:boolean = true;
  constructor(private loginService:LoginService) { 
      this.user = JSON.parse(sessionStorage.getItem('UserActive'));
      this.flag = (this.user.id_roles == 45)? false: true;
  }

  clickGuard(){
    this.loginService.clickGuard = true;
  }


}
